import React from 'react';

export const ListItems = (props) => {
  const items = props.list;
  const styles = props.styles;
  const location = window.location.pathname;
  return (
    items &&
    items.map((item, index) => (
      <div className={styles.divTable__cell} key={index}>
        <div className={styles.divTable__cellItem} style={{ justifyContent: 'flex-start' }}>
          <tr style={{ marginLeft: '24px' }}>
            <td style={{ verticalAlign: 'middle', paddingRight: '5px' }}>
              <img src={item.CurrencyFlagPath} alt="" />
            </td>
            <td>{location === '/rates' ? item.ID : item.CurCode}</td>
          </tr>
        </div>
        <div className={styles.divTable__cellItem}>{item.BankRate}</div>
        <div className={styles.divTable__cellItem}>{item.CashBuy}</div>
        <div className={styles.divTable__cellItem}>{item.CashSell}</div>
      </div>
    ))
  );
};
